
import StyleSheetRW from 'core/StyleSheetRW';
import navhelper from 'core/navhelper';
import React, { useEffect } from 'react';

interface ToastNotificationProps {
  message: string;
  link: string;
  visible: boolean;
  duration?: number;
  heading: string;
  onClose: () => void;
}

const ToastNotification: React.FC<ToastNotificationProps> = ({ heading, message, link, visible, duration = 5000, onClose }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleClick = () => {
    navhelper.push(link);
    onClose();
  };

  return (
    <>
      {visible && (
        <div style={styles.toast} onClick={handleClick}>
          <h2 style={styles.heading}>{heading}</h2>
          <div style={styles.message}>{message}</div>
        </div>
      )}
    </>
  );
};

export default ToastNotification;

const styles = StyleSheetRW.create(() => ({
  toast: {
    position: "absolute",
    top: 20,
    right: 20,
    backgroundColor: "#ffffff",
    color: "white",
    padding: "10px 20px",
    borderRadius: "10px",
    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
    cursor: "pointer",
    opacity: 1,
    transition: "opacity 0.5s ease-out",
    width: "300px",
    maxHeight: "120px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    zIndex: 1000,
  },
  message: {
    color: "#2F4858",
    fontSize: 16,
    fontWeight: "300",
    fontFamily: "Outfit",
    textAlign: "justify",
    margin: '3px 0px 0px 2px',
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 4,
    WebkitBoxOrient: "vertical",
  },
  heading: {
    color: "#2F4858",
    fontSize: 18,
    fontWeight: "600",
    fontFamily: "Outfit",
    textAlign: "justify",
    margin: '0px 0px 0px 2px',
  },
}));
